export default __webpack_public_path__ + "static/media/puppr-content-background-desktop.6466c959.png";